// extracted by mini-css-extract-plugin
module.exports = {"root":"FormSubmitButton_root__3CsqS","btnText":"FormSubmitButton_btnText__Cc6gm","iconText":"FormSubmitButton_iconText__r7OtW","btnBg":"FormSubmitButton_btnBg__orSRd"};